var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHelp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.31234 10.9167C9.31234 11.2964 9.62014 11.6042 9.99984 11.6042C10.3795 11.6042 10.6873 11.2964 10.6873 10.9167L10.6873 5.41669C10.6873 5.03699 10.3795 4.72919 9.99984 4.72919C9.62014 4.72919 9.31234 5.03699 9.31234 5.41669L9.31234 10.9167Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99984 19.8542C15.4421 19.8542 19.854 15.4423 19.854 10C19.854 4.55771 15.4421 0.145855 9.99984 0.145856C4.55753 0.145856 0.145671 4.55772 0.145671 10C0.145671 15.4423 4.55753 19.8542 9.99984 19.8542ZM18.479 10C18.479 14.6829 14.6828 18.4792 9.99984 18.4792C5.31692 18.4792 1.52067 14.6829 1.52067 10C1.52067 5.31711 5.31692 1.52086 9.99984 1.52086C14.6828 1.52086 18.479 5.31711 18.479 10Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.08317 13.6667C9.08317 13.1604 9.49358 12.75 9.99984 12.75C10.5061 12.75 10.9165 13.1604 10.9165 13.6667C10.9165 14.1729 10.5061 14.5834 9.99984 14.5834C9.49358 14.5834 9.08317 14.1729 9.08317 13.6667Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.c1953d9798b0223979c339c405cd1cd1.svg";
export { ForwardRef as ReactComponent };